import RoleEnum from '@/enums/roles'
import i18n from '@/plugins/vuei18n'
import PRINT_FIELD_GROUP from '@/enums/print/fieldGroup'

function printFieldLocation(field) {
  return {
    i: field.id,
    x: field.location.latitude,
    y: field.location.longitude,
    w: field.location.width,
    h: field.location.height
  }
}

export default {
  archiveFilters: state => state.archiveFilters,
  isAuthenticated: state => !!state.token,
  keepLogged: state => !!state.refreshToken,
  authStatus: state => state.authStatus,
  users: state => state.users,
  unlocatedFields: state => state.schemaBuilder.fields.filter(field => field.location === null),
  getType: state => id => state.fieldTypes.find(type => type.id === id),
  user: state => id => state.users.find(user => user.id === parseInt(id)),
  agency: state => id => state.agencies.find(agency => agency.id === parseInt(id)),
  relatedValuesType: state => id => state.relatedValuesType.find(valuesType => valuesType.idType === parseInt(id)),
  printLayout: state => {
    let dynamic = state.schemaBuilder.fields.filter(field => field.hasOwnProperty('location') && field.location != null).map(field => {
      return {
        ...printFieldLocation(field),
        name: field.name,
        group: PRINT_FIELD_GROUP.DYNAMIC
      }
    })
    let constant;
    let generated = []
    if (state.schemaBuilder.hasOwnProperty('print')) {
      constant = state.schemaBuilder.print.constant_fields.map(field => {
        return {
          ...printFieldLocation(field),
          group: PRINT_FIELD_GROUP.CONSTANT,
          value: field.value,
          type: field.type
        }
      })
      generated = state.schemaBuilder.print.generated_fields.map(field => {
        return {
          ...printFieldLocation(field),
          group: PRINT_FIELD_GROUP.GENERATED,
          type: field.type
        }
      })
    }
    return [].concat(generated, constant, dynamic)
  },
  relatedValues : state => (groupTypeId, code) => state.relatedValues.find(related => related.code == code && related['group_type_id'] == groupTypeId),
  roles: () => Object.values(RoleEnum.inUse),
  teams: state => state.teams,
  team: state => id => state.teams.find(team => team.id === id),
  lang : state => state.lang,
  tableTranslations: () => {
    return {
      rowsPerPageText: i18n.t('data-table.rows-per-page'),
      noDataText: i18n.t('data-table.no-data'),
      noResultsText: i18n.t('data-table.no-results')
    }
  },
  pagination: state => state.pagination,
  darkTheme: state => {
    if (typeof state.darkTheme === 'string') {
      return state.darkTheme === 'true'
    }
    return state.darkTheme
  },
  formField: state => order => state.forms.schema.fields.find(field => field.order == order),
  formType: state => state.forms.schema.type
}
